import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientSourceTableAndFilterSchema } from "model/ClientSourceModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientSourceContext = createContext();

export const ClientSourceProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientSourceContextData, setClientSourceContextData] = useState();

  const fetchClientSourceContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:clientSource", () =>
        fetchClientSourceTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientSourceContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch client source metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientSourceContext.Provider
      value={{
        fetchClientSourceContextData,
        clientSourceContextData,
        loading,
        error,
      }}
    >
      {children}
    </ClientSourceContext.Provider>
  );
};

export const useClientSourceContext = () => useContext(ClientSourceContext);
